<template>
	<v-col class="purchase-product">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Belanja Produk</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-cart</v-icon>
			<div class="pl-2">Transaksi Produk</div>
			<div class="px-2">/</div>
			<div>Belanja Produk</div>
		</div>
		<div class="mt-5">
			<div :class="first_step ? 'd-block' : 'd-none'">
				<StepSatu ref="stepSatu" @action="getFirstData"></StepSatu>
			</div>
			<div :class="second_step ? 'd-block' : 'd-none'">
				<StepDua :firstData="first_data" @action="getSecondData"></StepDua>
			</div>
			<div :class="third_step ? 'd-block' : 'd-none'">
				<StepTiga :shippingMethod="shipping_method" ref="stepTiga"></StepTiga>
			</div>
		</div>
	</v-col>
</template>

<script>
import StepSatu from './StepSatu';
import StepDua from './StepDua';
import StepTiga from './StepTiga';

export default {
	components: {
		StepSatu, StepDua, StepTiga
	},
	data() {
		return {
			first_step: true,
			second_step: false,
			third_step: false,
			first_data: [],
			shipping_method: '',
		}
	},
	computed: {
	},
	methods: {
		getFirstData(data) {
			this.first_data = data
			this.first_step = false
			this.second_step = true
		},
		getSecondData(step, shipping) {
			if (step == 'back') {
				this.first_step = true
				this.second_step = false
				this.$refs.stepSatu.getData()
			} else if (step == 'next') {
				this.shipping_method = shipping
				this.second_step = false
				this.third_step = true
				this.$refs.stepTiga.getData()
			}
		},
		// toStepTwo(step) {
		// 	if (step == 'back') {
		// 		this.second_step = true
		// 		this.third_step = false
		// 	}
		// }
	},
	created(){
		this.$store.dispatch('setPageTitle', `Belanja Produk`)
	},
};
</script>
